import React, { Component } from 'react'

import {
    SettingsCurrentSelection,
    SettingsTitle,
    SettingsRow,
    SettingsSelectIcon,
    InfoButton,
    InfoButtonWrapper
} from '../StyledComponents/Settings'
import { FillerInlineDiv } from '../StyledComponents/Fillers'

class SettingsRowSelect extends Component {
    constructor(props) {
        super(props)

        this.openSelect = this.openSelect.bind(this)
    }

    openSelect(e) {
        const {
            title,
            options,
            openSelection,
            type,
        } = this.props

        openSelection(title, options, type, e)
    }

    render() {
        const {
            title,
            selectedItem,
            options,
            isFirst,
            showInfoModal,
        } = this.props

        const currentSelection = options.filter(x => x.value === selectedItem)
        const currentLabel = currentSelection.length > 0 ? currentSelection[0].label : selectedItem

        const infoModal = showInfoModal ? (
            <InfoButtonWrapper marginLeft="0">
                <InfoButton onClick={showInfoModal}>?</InfoButton>
            </InfoButtonWrapper>
        ) : null

        return (
            <SettingsRow isFirst={isFirst}>
                <SettingsTitle className="align-top col-5">{title}</SettingsTitle>
                <FillerInlineDiv className="col-1">{infoModal}</FillerInlineDiv>
                <SettingsCurrentSelection className="col-5 text-right" onClick={this.openSelect}>
                    {currentLabel}
                </SettingsCurrentSelection>
                <SettingsSelectIcon className="col-1" name="angle-right" size="lg" />
            </SettingsRow>
        )
    }
}

export default SettingsRowSelect



// WEBPACK FOOTER //
// ./src/components/Settings/SettingsRowSelect.js